import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IPickMutation } from "../types";
import { getApi } from "../apiPath";
import { axiosClient, queryClient } from "../clients";

import type { IFaculties } from "./routeType";
import { useGetAllFaculties } from "./getAll";

const { getPath } = getApi("faculties.post");

type IExtractedRouteType = IFaculties["facultyCollectionCreate"];

export type IPostFaculty = IPickMutation<IExtractedRouteType>;

const postFaculty: MutationFunction<
  IPostFaculty["response"],
  IPostFaculty["variables"]
> = (data) => {
  return axiosClient.post(getPath(), data);
};

export const usePostFaculty = createMutation({
  mutationFn: postFaculty,
  onSuccess: () => {
    queryClient.invalidateQueries({ queryKey: useGetAllFaculties.getKey() });
  },
});
